import * as h2Api from '../h2Api'

export const REPORT_DATA_LOAD = 'PORTFOLIO_CLUSTER_REPORT_REPORT_DATA_LOAD'

export const TOGGLE_FILTER = 'PORTFOLIO_CLUSTER_REPORT_TOGGLE_FILTER'

export const REPORT_DATA_SAVE_PORTFOLIO = 'REPORT_DATA_SAVE_PORTFOLIO'

export const REPORT_DATA_SAVE_PORTFOLIO_DISMISS = 'REPORT_DATA_SAVE_PORTFOLIO_DISMISS'

export const assembleCombinedReport = data => {
  const combinedData = {}

  if (data.ip.isSummarizable) {
    data.ip.results.matches.forEach(m => {
      let d = combinedData[m.onetSoc]
      const bonus = m.value >= data.ip.results.strongMatch ? 1 : 0.5

      if (!d) {
        d = { numAssessments: 0, combinedScore: 0 }
      }

      combinedData[m.onetSoc] = {
        ...d,
        onetSoc: m.onetSoc,
        ip: m.value,
        combinedScore: d.combinedScore + bonus,
        numAssessments: d.numAssessments + 1
      }
    })
  }

  if (data.wip.isSummarizable) {
    data.wip.results.matches.forEach(m => {
      let d = combinedData[m.onetSoc]
      const bonus = m.value >= data.wip.results.strongMatch ? 1 : 0.5

      if (!d) {
        d = { numAssessments: 0, combinedScore: 0 }
      }

      combinedData[m.onetSoc] = {
        ...d,
        onetSoc: m.onetSoc,
        wip: m.value,
        combinedScore: d.combinedScore + bonus,
        numAssessments: d.numAssessments + 1
      }
    })
  }

  if (data.sp.isSummarizable) {
    data.sp.results.matches.forEach(m => {
      let d = combinedData[m.onetSoc]
      const bonus = m.value >= data.sp.results.strongMatch ? 1 : 0.5

      if (!d) {
        d = { numAssessments: 0, combinedScore: 0 }
      }

      combinedData[m.onetSoc] = {
        ...d,
        onetSoc: m.onetSoc,
        sp: m.value,
        combinedScore: d.combinedScore + bonus,
        numAssessments: d.numAssessments + 1
      }
    })
  }

  const retVal = Object.values(combinedData)
    .map(m => {
      return {
        ...m,
        combinedScore: m.numAssessments * 0.25 + m.combinedScore
      }
    })
    .sort((a, b) => b.combinedScore - a.combinedScore)

  return retVal
}

export const saveClusterReport = (user, filters) => dispatch => {
  return dispatch(
    h2Api.post(
      `/user/reports/cluster/${user ? `${user.id}/` : ''}save`,
      filters
    )({ type: REPORT_DATA_SAVE_PORTFOLIO, user })
  )
}

export const closeConfirm = () => dispatch => {
  dispatch({ type: REPORT_DATA_SAVE_PORTFOLIO_DISMISS })
}

export const print = filters => {
  h2Api.post('/pdfs/portfolio/summaryreport', filters)
}

export const loadClusterReport = () => {
  return h2Api.get('/user/reports/cluster')({ type: REPORT_DATA_LOAD })
}

export const loadClusterReportForUser = userId => {
  return h2Api.get(`/user/reports/cluster/${userId}`)({ type: REPORT_DATA_LOAD })
}

export const toggleFilter = name => dispatch => {
  dispatch({ type: TOGGLE_FILTER, name })
}

export const setNumToDisplay = numToDisplay => dispatch => {
  dispatch({ type: FILTER_NUM_TO_DISPLAY, numToDisplay })
}
